import React from "react";
import { Link } from "react-router";
import Version from "@/components/Version";

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-800 text-gray-400 py-4 px-6 mt-auto">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Logo and Copyright */}
          <div className="flex items-center gap-3">
            <img src="/bondit-logo-trans-bg.png" alt="BondIT Logo" className="h-8 w-auto" />
            <p className="text-sm">© {currentYear} BondIT Denmark ApS. All rights reserved.</p>
          </div>

          {/* Links */}
          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
            <a
              href="https://bondit.dk/privacy-policy?utm_source=consultant-portal&utm_medium=footer&utm_campaign=footer-links"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block py-1.5 -my-1.5 text-sm hover:text-white transition-colors duration-200"
            >
              Privacy Policy
            </a>
            <a
              href="https://bondit.dk/terms-of-service?utm_source=consultant_portal&utm_medium=footer&utm_campaign=app_links"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block py-1.5 -my-1.5 text-sm hover:text-white transition-colors duration-200"
            >
              Terms of Service
            </a>
            <a
              href="https://bondit.dk/en?utm_source=consultant_portal&utm_medium=footer&utm_campaign=app_links#contact"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block py-1.5 -my-1.5 text-sm hover:text-white transition-colors duration-200"
            >
              Contact Us
            </a>
            <Link
              to="/privacy-settings"
              className="inline-block py-1.5 -my-1.5 text-sm hover:text-white transition-colors duration-200"
            >
              Privacy Settings
            </Link>
            <Version className="inline-block py-1.5 -my-1.5 text-xs text-gray-400" />
          </div>

          {/* Social Media Icons */}
          <div className="flex items-center gap-4">
            <a
              href="https://www.linkedin.com/company/bondit-dk/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex p-1.5 -m-1.5 hover:text-white transition-colors duration-200"
              aria-label="LinkedIn"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
              </svg>
            </a>
            <a
              href="https://twitter.com/bondit_aps"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex p-1.5 -m-1.5 hover:text-white transition-colors duration-200"
              aria-label="Twitter"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
